// The typed flag structure (settled decision 5): future story beats, eggs,
// and one-way progression markers live here instead of ad-hoc booleans.
// Serialized as a string array; joins the SAVE as part of step 7's v4
// migration — until then this module is unit-locked but not persisted.

/** Every known flag. `endingReached` is the founding member. */
export type FlagName = 'endingReached'

const KNOWN: readonly FlagName[] = ['endingReached']

export interface Flags {
  has(name: FlagName): boolean
  set(name: FlagName): void
  clear(name: FlagName): void
}

export function createFlags(initial: Iterable<string> = []): Flags & { _set: Set<string> } {
  const s = new Set<string>(initial)
  return {
    _set: s,
    has: name => s.has(name),
    set: name => { s.add(name) },
    clear: name => { s.delete(name) },
  }
}

/**
 * Save form: known flags first in KNOWN order (`endingReached` always first
 * when present), then unknown names in insertion order — unknown flags from
 * a newer version survive a round-trip through an older one.
 */
export function serializeFlags(flags: { _set: Set<string> }): string[] {
  const known = KNOWN.filter(k => flags._set.has(k))
  const unknown = [...flags._set].filter(n => !(KNOWN as readonly string[]).includes(n))
  return [...known, ...unknown]
}

export function deserializeFlags(arr: unknown): Flags & { _set: Set<string> } {
  if (!Array.isArray(arr)) return createFlags()
  return createFlags(arr.filter((x): x is string => typeof x === 'string'))
}
